import React, { useState, useRef, useEffect } from "react";
import { SketchPicker } from 'react-color';
import { isSet } from '../../../../Utils/CommonFunctions';

const BackgroundColor = (props) => {
  //console.log('props.isFrom===',props.isFrom)
  const {path,keyParam,value,elementData,isFrom } = props;
  const colorValue = isSet(elementData.attributes.style[props.keyParam],null)!==null?elementData.attributes.style[props.keyParam]:'#ffffff';
  const [showPicker, setShowPicker] = useState(false);
  const colorPickerRef = useRef(null);

  const handleDocumentClick = (event) => {
    if (colorPickerRef.current && !colorPickerRef.current.contains(event.target)) {
        setShowPicker(false);
        // console.log('sss');
    }
  };

  useEffect(() => {
    if(showPicker===true){
        document.addEventListener('click', handleDocumentClick);
    }
   

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [showPicker]);

  const handleChangeComplete = (colorval) => {
    // console.log('colorval',colorval);
    props.changeHandler(path,keyParam,colorval.hex);
    // setColor(newColor.hex);
  };

  const handleIconClick = () => {
    setShowPicker(!showPicker);
  };

  return (
    <div style={{ position: 'relative' }}>
      <span
        onClick={handleIconClick}
        className="colorinput-color"
        style={{ cursor: 'pointer', backgroundColor: colorValue, zIndex: showPicker ? 1 : 'auto' }}
      ></span>
      {showPicker && (
        <div
          className="color-pallet-modal"
          style={{
            position: 'absolute',
            top: '40px',
            right: '0',
            zIndex: 99999,
          }}
          ref={colorPickerRef}
        >
          <SketchPicker color={colorValue} onChangeComplete={handleChangeComplete} />
        </div>
      )}
    </div>
  );
};

BackgroundColor.defaultProps = {
    value: '#000000',
    colorValue: '#000000'
};

export default BackgroundColor;
